// extracted by mini-css-extract-plugin
export default {"customBtn":"styles_customBtn__fUhjx"};